import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TopBarHome from "../components/TopBarHome";
import completeImg from "./../assets/img/complete.jpeg"
const { innerWidth } = window;

const CompleteScreen = () => {
    const navigate = useNavigate();
    const [secondsTimeout, setSecondsTimeout] = useState(0);


    useEffect(() => {
        setSecondsTimeout(20);

        const interval = setInterval(() => {
            setSecondsTimeout(prevSeconds => {
                if (prevSeconds === 0) {
                    clearInterval(interval);
                    localStorage.removeItem('praticaTotem');
                    navigate('/homepage', { state: {isTotem: true}})
                    return 0;
                }
                return prevSeconds - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [])

    return (
        <TopBarHome>
            <div className="pol-content" >
                <div style={{
                    color: '#003897', fontFamily: 'Poppins-SemiBold', fontSize: innerWidth < 500 ? 18 : 24, marginLeft: 15, marginRight: 15,
                    marginBottom: 60, marginTop: 50, display: 'flex', justifyContent: 'center', textAlign: 'center'
                }}>
                    La tua richiesta è andata a buon fine!
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 60 }}>
                    <img src={completeImg} alt="Banco Azzoaglio" width={'100%'} height={'100%'} style={{ maxWidth: innerWidth < 500 ? 274 : 550 }} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <div style={{ display: 'flex', flexDirection: innerWidth < 500 ? 'column' : 'row', width: '70%', justifyContent: 'center' }}>
                        <div style={{
                            borderRadius: 20, margin: 20, fontFamily: 'Poppins-Regular', fontSize: 16, /* textAlign: 'center',  maxWidth: 400,*/
                            backgroundColor: '#EFF4FD', padding: 15, boxShadow: "-3px 3px 10px #d2d6df", minHeight: 150, paddingTop: 30,
                            paddingBottom: 30
                        }}>
                            A breve riceverai:
                            <br />
                            <ul>
                                <li>
                                una mail contenente le istruzioni per firmare la contrattualistica
                                </li>
                                <li>
                                il kit di benvenuto con la tua nuova carta di debito
                                </li>
                            </ul>
                            Se hai dei dubbi, contattaci via mail a @azzoaglio.it oppure telefonicamente al 0174 7241.
                            <br/>
                        </div>
                    </div>
                </div>
                <div style={{
                    color: '#003897', fontFamily: 'Poppins-SemiBold', fontSize: innerWidth < 500 ? 22 : 28, marginLeft: 15, marginRight: 15,
                    marginBottom: 60, marginTop: 50, display: 'flex', justifyContent: 'center', textAlign: 'center'
                }}>
                    Grazie e arrivederci.
                </div>
            </div>
        </TopBarHome >
    );
};

export default CompleteScreen;
